import memoizeOne from 'memoize-one';

import { EditorCardProvider } from '@atlaskit/editor-card-provider';

import { InlineCommentEditorCardProvider } from '@confluence/comments-util/entry-points/classes';

export const getSmartCardOptions = memoizeOne((enableChromelessEditorCardProvider: boolean) => {
	/**
	 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
	 * (only supports Cloud single-issue URLs right now)
	 */
	const smartLinksBeforeMacros =
		'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(
			',',
		);

	const cardProvider = Promise.resolve(
		enableChromelessEditorCardProvider
			? new InlineCommentEditorCardProvider(undefined, undefined, 'CONFLUENCE')
			: new EditorCardProvider(undefined, undefined, 'CONFLUENCE'),
	);

	// IMPORTANT: If you change the code below, please also update the
	// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
	// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
	return {
		provider: cardProvider,
		resolveBeforeMacros: smartLinksBeforeMacros,
		allowBlockCards: true,
		allowEmbeds: true,
	};
});
